import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StakeHolderPage from "./pages/StakeHolderPage";
import ThemePage from "./pages/ThemePage";
import ViewProfilePage from "./pages/ViewProfilePage";
import WidgetsPage from "./pages/WidgetsPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import BinanceBalancePage from "./pages/BinanceBalancePage";
import BlankPagePage from "./pages/BlankPagePage";
import OverviewPage from "./pages/OverviewPage";
import IndividualClientPage from "./pages/IndividualClient";
import IndividualClientDetailsPage from "./pages/IndividualClientDetailsPage";
import CorporateClientPage from "./pages/CorporateClient";
import EquityPage from "./pages/EquityPage";
import BankPage from "./pages/BankPage";
import CorporateClientDetailsPage from "./pages/CorporateClientDetailsPage";
import PuneetShareClassPage from "./pages/PuneetShareClassPage";

function AppContent() {
  const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR.png`;
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation(); // Detect route changes

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Simulate a 1-second loading delay

    return () => clearTimeout(timeout);
  }, [location.pathname]); // Re-run on route change

  return (
    <>
      <RouteScrollToTop />
      {isLoading && (
      <div className="loading-screen d-flex flex-column align-items-center justify-content-center">
        <img className="loading-logo mb-3" src={imagePath2} alt="Logo" style={{ width: "200px" }} />
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )}

      <Routes>
        <Route exact path="/overview" element={<OverviewPage />} />
        <Route exact path="/banks-balance" element={<BankPage />} />
        <Route exact path="/equity-balance" element={<EquityPage />} />
        <Route exact path="/binance-balance" element={<BinanceBalancePage />} />
        <Route exact path="/multi-asset/ind-clients" element={<IndividualClientPage />} />
        <Route exact path="/multi-asset/corp-clients" element={<CorporateClientPage />} />
        <Route exact path="/digital-asset/ind-clients" element={<IndividualClientPage />} />
        <Route exact path="/digital-asset/ind-client-details/:id" element={<IndividualClientDetailsPage />} />
        <Route exact path="/digital-asset/corp-clients" element={<CorporateClientPage />} />
        <Route exact path="/digital-asset/corp-client-details/:id" element={<CorporateClientDetailsPage />} />

        <Route exact path="/puneet-share-class" element={<PuneetShareClassPage />} />


        <Route exact path="/" element={<SignInPage />} />
        <Route exact path="/documents" element={<CalendarMainPage />} />
        <Route exact path="/bank-documents" element={<ChatMessagePage />} />
        <Route exact path="/basic-info" element={<EmailPage />} />
        <Route exact path="/stakeholders" element={<StakeHolderPage />} />
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/forgot-passwords" element={<ForgotPasswordPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;